module.exports = __webpack_public_path__ + "img/service_item.d05c6e94.png";